module.exports = __webpack_public_path__ + "static/media/income-calc.2bd3834f.svg";